<form class="row"
      novalidate
      *ngIf="form"
      [formGroup]="form"
      (keyup.enter)="submit()"
>
  <div class="col-12">
    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md">I am a:</label>
      </div>
      <p-dropdown
        name="role"
        [options]="roles"
        [placeholder]="placeholder"
        [formControl]="role"
      >
        <ng-template let-selectedRole pTemplate="selectedItem">
          <div class="d-flex align-items-center" *ngIf="selectedRole && visible">
            <app-icon [icon]="selectedRole.icon"></app-icon>
            <div class="ml-2">{{ selectedRole.value | titlecase }}</div>
          </div>
        </ng-template>
        <ng-template let-role pTemplate="item">
          <div class="d-flex align-items-center" >
            <app-icon [icon]="role.icon"></app-icon>
            <div class="ml-2">{{ role.value | titlecase }}</div>
          </div>
        </ng-template>
      </p-dropdown>

      <div class="position-relative">
        <small class="p-error"
               *ngIf="role.dirty && role.invalid"
        >
          {{ getErrorMessage('Role', role) }}
        </small>
      </div>
    </div>
  </div>

  <div class="col-12 mt-5">
    <button pButton
            class="p-button-md w-100"
            type="submit"
            label="CONTINUE"
            [disabled]="form.invalid"
            (click)="submit()"
    ></button>
  </div>

  <div class="col-12 mt-3">
    <p>
      Back to
      <a class="p-link"
         routerLink="/auth/login"
      >
        Login page
      </a>
    </p>
  </div>
</form>
